<template>
  <article>
    <div class="dataForm">
      <div class="dataForm__item">
        <div class="dataForm__name">订单ID</div>
        <el-input v-model="detail.oid" placeholder="" size="mini" class="dataForm__input" :disabled="true"></el-input>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">用户ID</div>
        <el-input v-model="detail.uid" placeholder="" size="mini" class="dataForm__input" :disabled="true"></el-input>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">用户昵称</div>
        <el-input v-model="detail.nickname" placeholder="" size="mini" class="dataForm__input" :disabled="true"></el-input>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">跟单人</div>
        <el-select class="filter__input" size="mini" v-model="detail.opid">
          <el-option :label="item.nickname" :value="item.opid" v-for="(item, index) in operLists" :key="index"></el-option>
        </el-select>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">活动名称</div>
        <el-select placeholder="请选择" v-model="detail.adid" :disabled="detail.oid">
          <el-option v-for="item in adLists" :key="item.value" :label="item.title" class="dataForm__input"  :value="item.adid"> </el-option>
        </el-select>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">购买类型</div>
        <el-radio-group v-model="detail.purchase">
          <div class="dib mr-20">
            <el-radio :label="0">需要返款</el-radio>
            <el-radio :label="1">直接折扣</el-radio>
            <el-radio :label="2">假单</el-radio>
            <el-radio :label="3">囤货</el-radio>
            <el-radio :label="4">固返</el-radio>
          </div>
        </el-radio-group>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">是否开启对公</div>
        <el-radio-group v-model="detail.use_corp">
          <div class="dib mr-20">
            <el-radio :label="0">否</el-radio>
            <el-radio :label="1">是</el-radio>
          </div>
        </el-radio-group>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">金额</div>
        <el-input v-model="detail.payment" placeholder="" size="mini" class="dataForm__input"></el-input>
      </div>
      <div class="dataForm__item mt-16" v-if="[2].includes(opid)">
        <div class="dataForm__name">广告折扣</div>
        <el-input v-model="detail.aver_discount" placeholder="" size="mini" class="dataForm__input" :disabled="![2].includes(opid)">
          <template slot="append">%</template>
        </el-input>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">底价折扣</div>
        <el-input v-model="detail.min_discount" placeholder="" size="mini" class="dataForm__input" :disabled="![2].includes(opid)">
          <template slot="append">%</template>
        </el-input>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">折扣</div>
        <el-input v-model="detail.discount" placeholder="" size="mini" class="dataForm__input">
          <template slot="append">%</template>
        </el-input>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">订单号</div>
        <el-input v-model="detail.orderid" placeholder="" size="mini" class="dataForm__input" :disabled="detail.oid"></el-input>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">实付金</div>
        <el-input v-model="detail.final_payment" placeholder="" size="mini" class="dataForm__input"></el-input>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">用户折扣</div>
        <el-input v-model="detail.user_discount" placeholder="" size="mini" class="dataForm__input">
          <template slot="append">%</template>
        </el-input>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">拍收费</div>
        <el-input v-model="detail.agency_fees" placeholder="" size="mini" class="dataForm__input"></el-input>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">额外信息</div>
        <el-input v-model="detail.extra" placeholder="" size="mini" class="dataForm__input"></el-input>
      </div>
      <div class="dataForm__item mt-20">
        <div class="dataForm__name ml40">预售截图</div>
        <div class="headimg-container relative" style="width:250px">
          <uploadHeadImage :url.sync="detail.presale_img" :itype="5"></uploadHeadImage>
        </div>
      </div>
      <div class="dataForm__item mt-20">
        <div class="dataForm__name ml40">报单截图</div>
        <div class="headimg-container relative" style="width:250px">
          <uploadHeadImage :url.sync="detail.payment_img" :itype="5"></uploadHeadImage>
        </div>
      </div>
      <div class="dataForm__item mt-20">
        <div class="dataForm__name ml40">完成截图</div>
        <div class="headimg-container relative" style="width:250px">
          <uploadHeadImage :url.sync="detail.finish_img" :itype="5"></uploadHeadImage>
        </div>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">备注</div>
        <el-input v-model="detail.remark" placeholder="" size="mini" class="dataForm__input"></el-input>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">日期</div>
        <el-date-picker v-model="detail.date" type="date" placeholder="选择日期"> </el-date-picker>
      </div>
      <div class="dataForm__item mt-16" v-if="detail.oid != 0">
        <div class="dataForm__name">状态</div>
        <el-radio-group v-model="detail.status">
          <div class="dib mr-20">
            <el-radio :label="7">预售</el-radio>
            <el-radio :label="0">报单</el-radio>
            <el-radio :label="1">跟单中</el-radio>
            <el-radio :label="2">完成订单</el-radio>
            <el-radio :label="5">失效</el-radio>
            <el-radio :label="6">拒绝</el-radio>
          </div>
        </el-radio-group>
      </div>
      <div class="flex fdr">
        <div class="dataForm__item mt-16 mr-20">
          <div class="dataForm__name">对接状态</div>
          <dockingStatusSelect v-model="detail.docking_status" />
        </div>
        <div class="dataForm__item mt-16 mr-20">
          <div class="dataForm__name">AI报单图识别</div>
          <aiReviewUploadSelect v-model="detail.ai_review_upload" />
        </div>
        <div class="dataForm__item mt-16">
          <div class="dataForm__name">AI完成图识别</div>
          <aiReviewFinishSelect v-model="detail.ai_review_finish" />
        </div>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name"></div>
        <button class="blue-large-btn" @click="adOrderEdit">保存</button>
      </div>
    </div>
  </article>
</template>

<script>
import util from '../../../script/util'
import {adConciseLists, adOrderDetail, adOrderEdit, operLists} from '../../../api/api'
import dockingStatusSelect from '../../../components/data-select/dockingStatusSelect'
import aiReviewUploadSelect from '../../../components/data-select/aiReviewUploadSelect'
import aiReviewFinishSelect from '../../../components/data-select/aiReviewFinishSelect'
import uploadHeadImage from '../../../components/uploadImage.vue'
export default {
  name: 'adOrderEdit',
  components: {
    uploadHeadImage,
    dockingStatusSelect,
    aiReviewUploadSelect,
    aiReviewFinishSelect
  },
  data () {
    return {
      detail: {
        oid: 0,
        uid: 10000,
        username: '',
        nickname: '报单专用',
        opid: 1,
        adid: '',
        purchase: 1,
        payment: '',
        aver_discount: '',
        min_discount: '',
        discount: '',
        use_corp: 0,
        orderid: '',
        final_payment: '',
        user_discount: '',
        agency_fees: 0,
        commission: '',
        extra: '',
        presale_img: '',
        payment_img: '',
        finish_img: '',
        remark: '',
        date: new Date(),
        docking_status: 0,
        ai_review_upload: 0,
        ai_review_finish: 0,
        status: 0
      },
      dialog: false,
      dateTime: '',
      adLists: [],
      operLists: [],
      statusList: [
        {
          name: '正常',
          value: 1
        },
        {
          name: '停止',
          value: 0
        }
      ]
    }
  },
  methods: {
    changeAdid () {
      this.adLists.forEach((item) => {
        if (item.adid === this.detail.adid && this.detail.oid === 0) {
          this.detail.min_discount = item.min_discount
        }
      })
    },
    getOperLists () {
      let params = {
        market: 3,
        l: 500,
        p: 1
      }
      operLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.operLists = data.d.lists.map((item, index) => {
            return {
              nickname: item.nickname,
              opid: item.opid
            }
          })
        }
      })
    },
    getAdLists () {
      let params = {
        market: 3,
        l: 500,
        p: 1
      }
      adConciseLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.adLists = data.d.lists.map((item, index) => {
            return {
              title: item.title,
              adid: item.adid,
              min_discount: item.min_discount
            }
          })
          this.changeAdid()
        }
      })
    },
    adOrderDetail () {
      let params = {
        oid: this.detail.oid
      }
      this.loading = true
      adOrderDetail(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.detail = data.d
          this.detail.date = new Date(this.detail.date * 1000)
        }
        this.loading = false
      })
    },
    adOrderEdit () {
      let params = util.cloneObj(this.detail)
      params['date'] = parseInt(this.detail.date.getTime() / 1000)

      if (![2].includes(this.opid)) {
        delete params.aver_discount
        delete params.min_discount
      }

      let content = ''

      if (params.discount < 0 || params.discount > 100) {
        content = '折扣不正确'
      }

      if (params.user_discount < 0 || params.user_discount > 100) {
        content = '用户折扣不正确'
      }

      if (params.presale_img === '' && params.payment_img === '') {
        content = '请上传预售或者下单截图'
      }

      if (params.status === 2 && params.finish_img === '') {
        content = '请上传完成截图'
      }

      if (content) {
        this.$notify({
          title: '失败',
          message: content,
          type: 'error'
        })
        return
      }

      adOrderEdit(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.$notify({
            title: '成功',
            message: '保存成功',
            type: 'success'
          })
          this.$router.push('/adOrder')
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
      })
    }
  },
  watch: {
    'detail.adid': 'changeAdid'
  },
  mounted () {
    this.opid = parseInt(window.localStorage.getItem('opid'))
    this.detail.oid = parseInt(this.$route.query.oid || 0)
    if (this.detail.oid) {
      this.adOrderDetail()
    }

    this.getOperLists()
    this.getAdLists()
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/page/module/ad/adOrderEdit.vue